import { ReactComponent } from "components/community/feed/reactions/reactComponent"

export const ReactModale = ({ isClosing } : { isClosing?: boolean}) => {
    return (
        <div className="w-full lg:w-[500px] h-full">
            <ReactComponent isClosing={isClosing}/>
        </div>
    )
}